import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { ActionCreators } from "../../../redux/actions"

import ContentList from "../Bits/ContentList"

class EditRigs extends Component {
  componentDidMount() {
    const { getRigList } = this.props
    getRigList()
  }

  handleDeleteFormSubmit = (selectedItems) => {
    const { deleteItems } = this.props
    deleteItems("rig", selectedItems)
  }

  editItem = (item) => {
    const { editSingleItem } = this.props
    editSingleItem("rig", item)
  }

  addItem = () => {
    const { editSingleItem } = this.props
    editSingleItem("rig", { name: "" })
  }

  render() {
    const { rigs } = this.props

    return (
      <div className="ManageContent__Content">
        <ContentList
          hideAddButton={true}
          addItem={this.addItem}
          editItem={null}
          deleteItemsFunc={this.handleDeleteFormSubmit}
          header={"Edit rigs"}
          items={rigs}
        />
      </div>
    )
  }
}

EditRigs.propTypes = {
  editSingleItem: PropTypes.func,
  getRigList: PropTypes.func,
  deleteItems: PropTypes.func,
  rigs: PropTypes.array,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch)
}

function mapStateToProps(state) {
  return {
    rigs: state.managecontent.rigs,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRigs)
